import { useIsSSRMode } from '../../../hooks/useIsSSRMode';

const RenderPixel = ({ selectorId }) => {
  const isSSR = useIsSSRMode();
  return isSSR ? <span data-id={`rendering-pixel-${selectorId}`}></span> : null;
};

export default RenderPixel;
